// react
import React from "react";

const Loading = () => {
    return (
        <>
            <h6 className="text-center mb-0">
                <span className="spinner card-title spinner-border"></span>
                <p className="mb-0">
                    در حال بارگذاری اطلاعات
                </p>
            </h6>
        </>
    )
}

export default Loading;